import { GenderLabels } from "../constants";
import { FieldDefinition } from "./fieldDefinitions";

export const patientFields: FieldDefinition[] = [
  { name: "lastName", label: "Επώνυμο", type: "text", required: true },
  { name: "firstName", label: "Όνομα", type: "text", required: true },
  {
    name: "birthDate",
    label: "Ημερομηνία Γέννησης",
    type: "date",
    required: true,
  },
  {
    name: "gender",
    label: "Φύλο",
    type: "select", //  ΠΡΟΣΟΧΗ: Πρέπει να είναι "select"
    required: true,
    options: Object.keys(GenderLabels).map((key) => ({
      value: Number(key),
      label: GenderLabels[Number(key)],
    })),
  },
  { name: "amka", label: "ΑΜΚΑ", type: "text", required: true },
  { name: "weight", label: "Βάρος", type: "number" },
  { name: "height", label: "Ύψος", type: "number" },
  { name: "email", label: "Email", type: "email" },
  { name: "mobile", label: "Κινητό", type: "text" },
  { name: "telephone", label: "Τηλέφωνο", type: "text" },
  { name: "telephone2", label: "Τηλέφωνο 2", type: "text" },
  { name: "road", label: "Οδός", type: "text" },
  { name: "roadNumber", label: "Αριθμός", type: "text" },
  { name: "city", label: "Πόλη", type: "text" },
  { name: "remarks", label: "Παρατηρήσεις", type: "text" },
  { name: "nearestFirstname", label: "Όνομα Οικείου", type: "text" },
  { name: "nearestLastname", label: "Επώνυμο Οικείου", type: "text" },
  { name: "nearestTelephone1", label: "Τηλέφωνο Οικείου 1", type: "number" },
  { name: "nearestTelephone2", label: "Τηλέφωνο Οικείου 2", type: "number" },
  { name: "nearestEmail", label: "Email Οικείου", type: "email" },
] as const;

type Field = (typeof patientFields)[number];
export type PatientFormData = { [K in Field["name"]]: string | number };

export const patientFilters = patientFields.filter((f) =>
  ["lastName", "firstName", "amka", "gender"].includes(f.name),
);

export interface PatientDto extends PatientFormData {
  patientId: number; // Ή όποιο ID field έχεις
}
export interface CreatePatientDto extends PatientFormData {}
export const patientFormData: string[] = [
  "lastName",
  "firstName",
  "birthDate",
  "gender",
  "amka",
  "weight",
  "height",
  "email",
  "mobile",
  "telephone",
  "telephone2",
  "road",
  "roadNumber",
  "city",
  "remarks",
  "nearestFirstname",
  "nearestLastname",
  "nearestTelephone1",
  "nearestTelephone2",
  "nearestEmail",
];
export const patientKeyId = "patientId" as const;
